export default __webpack_public_path__ + "static/media/certifiedEnglish.753fc7a6.png";